export enum VoteType {
	LIKE = "LIKE",
	DISLIKE = "DISLIKE",
}
